"use client";

import { useEffect, useState } from "react";
import posthog from "posthog-js";

export function useFeatureFlag<T extends string | boolean>(
  key: string,
  defaultValue: T,
): T {
  const [value, setValue] = useState<T>(defaultValue);

  useEffect(() => {
    // Force a /flags fetch — bypasses PostHog's remote-config hasFeatureFlags
    // optimization which is returning false for this project even though flags exist.
    posthog.reloadFeatureFlags();

    const current = posthog.getFeatureFlag(key);
    if (current !== undefined) setValue(current as T);

    return posthog.onFeatureFlags(() => {
      const next = posthog.getFeatureFlag(key);
      setValue((next ?? defaultValue) as T);
    });
  }, [key, defaultValue]);

  return value;
}
